var map = {
	"./1.png": 1017,
	"./10.png": 1018,
	"./11.png": 1019,
	"./2.png": 1020,
	"./3.png": 1021,
	"./4.png": 1022,
	"./5.png": 1023,
	"./6.png": 1024,
	"./7.png": 1025,
	"./Api.svg": 1026,
	"./CloudCanvas.svg": 1027,
	"./Customers/VPC-IT.jpg": 948,
	"./Customers/VPC-banks.jpg": 949,
	"./Customers/VPC-innovation.jpg": 950,
	"./Customers/VPC-insurance.jpg": 951,
	"./Firewall.svg": 1028,
	"./LoadBalancers.svg": 1029,
	"./NetworkTopology.svg": 1030,
	"./Step1-m.svg": 1031,
	"./Step1.svg": 1032,
	"./Step2-m.svg": 1011,
	"./Step2.svg": 1012,
	"./Step3.svg": 1013,
	"./VPC-Main.svg": 1033,
	"./VPC_Info.svg": 1034,
	"./VS.svg": 876,
	"./VirtualMachins.svg": 1035,
	"./Volumes.svg": 1036,
	"./backup.svg": 1037,
	"./blancing.svg": 1038,
	"./cancle.svg": 877,
	"./cloud-security.svg": 1039,
	"./cloudstorage.svg": 881,
	"./cover-video.jpg": 1040,
	"./dashboard.svg": 1041,
	"./datacenter.svg": 882,
	"./firewall.png": 1042,
	"./freeSupport.svg": 1043,
	"./header.svg": 913,
	"./hq.svg": 1044,
	"./image.svg": 1045,
	"./improve.svg": 1046,
	"./infrustructure.svg": 1047,
	"./ip.png": 1048,
	"./network.png": 1049,
	"./openstack.svg": 1050,
	"./platform.png": 1051,
	"./sazman.svg": 1052,
	"./sdn.svg": 1053,
	"./section-header.svg": 1054,
	"./security.svg": 1055,
	"./service-mgs.svg": 1056,
	"./signup.svg": 1057,
	"./sla.svg": 1058,
	"./snapshot.svg": 1059,
	"./store.svg": 1060,
	"./support.svg": 1061,
	"./tick.svg": 878,
	"./video.png": 1062,
	"./vpc-patform.png": 1063,
	"./vpc1.png": 1064,
	"./vpc10.png": 1065,
	"./vpc100.png": 1066,
	"./vpc11.png": 1067,
	"./vpc12.png": 1068,
	"./vpc13.png": 1069,
	"./vpc15.png": 1070,
	"./vpc17.png": 1071,
	"./vpc18.png": 1072,
	"./vpc19.png": 1073,
	"./vpc2.png": 1074,
	"./vpc3.png": 1075,
	"./vpc4.png": 1076,
	"./vpc5.png": 1077,
	"./vpc_platform.png": 1078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;